import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { PlusOutlined } from '@ant-design/icons';
import { deleteIllnesses, getIllnesses } from '../../network/illnesses';
import { useSelector } from 'react-redux';
import { ModalAppIllness } from '../../components/upeosoft/ModalApp/ModalApp';

const Illness = ({ t }) => {
  const client = useQueryClient();
  const { currentLang } = useSelector((state) => state.user);
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteIllnesses(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message ? data?.message : 'Deleted successfully');
        client.invalidateQueries({ queryKey: [queryKeys.getIllnesses] });
      },
      onError: () => {
        message.error('Something went wrong');
      },
    }
  );
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getIllnesses, currentLang],
    queryFn: () => getIllnesses(currentLang),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.Name,
      dataIndex: currentLang === 'en' ? 'en' : 'ar',
      key: currentLang === 'en' ? 'en' : 'ar',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(
          record?.[currentLang === 'en' ? 'en' : 'ar']
        ).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        return (
          <Space>
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title="Delete the Illness?"
              description="Are you sure to delete this illness?"
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText="Yes"
              cancelText="No"
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    // console.log('item:', item);
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      <Heading title={t.settings} subTitle={t.illnesses} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        Placeholder={t.searchByName}
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />
            {t.AddIllness}
          </Button>
        }
      />
      <ModalAppIllness
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        t={t}
      />
    </div>
  );
};

export default Illness;
